export default {"src":"/_next/static/media/linkedin.37dba60c.ico","height":266,"width":270,"blurWidth":0,"blurHeight":0};